import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { useState as a, useCallback as m, useEffect as O, cloneElement as T } from "react";
import N from "classnames";
import { noop as M } from "lodash/fp";
import t from "./index.es5820.js";
import { SectionTitle as V } from "./index.es87.js";
import { SectionMore as q } from "./index.es5545.js";
import { SectionMenuFooter as B } from "./index.es5547.js";
const D = ({
  items: S,
  footer: v,
  isShowMoreEnabled: d = !0,
  searchTerm: j,
  onCollectiveSelection: f = M,
  onMenuItemClick: p = M
}) => {
  const [x, u] = a([]), [h, F] = a([]), [I, C] = a([]), b = m((o, e) => {
    u(o === "Show more" ? (n) => [.../* @__PURE__ */ new Set([...n, e])] : (n) => n.filter((s) => s !== e));
  }, []), g = m(
    (o) => {
      p(o), F((e) => [...e, o]);
    },
    [p]
  ), k = m((o, e) => {
    C(o ? (n) => n.filter((s) => s !== e) : (n) => [.../* @__PURE__ */ new Set([...n, e])]);
  }, []);
  return O(() => {
    f(h);
  }, [h, f]), /* @__PURE__ */ l("div", { className: t.root, children: [
    /* @__PURE__ */ r("div", { className: t.sectionContainer, children: S.map(
      ({ title: o, showMore: e, Menu: n, showChevron: s, NoResultItem: y, ...z }, w) => {
        const A = e === void 0, c = x.includes(o) ? "Show less" : "Show more", i = I.includes(o), E = N(t.menuContainer, {
          [t.more]: !d || A || c !== "Show more"
        }), L = N(t.contentContainer, {
          [t.lastContent]: w === S.length - 1,
          [t.firstContent]: w === 0
        });
        return /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ r(
            V,
            {
              title: o,
              showChevron: s,
              ...z,
              onCollapse: () => {
                s && k(i, o);
              },
              isCollapsed: i
            }
          ),
          !i && /* @__PURE__ */ l("div", { className: L, children: [
            /* @__PURE__ */ r("div", { className: E, children: T(n, {
              onItemSelection: g,
              searchTerm: j,
              NoResultItem: y,
              disabledVirtualization: !0
            }) }),
            e && d && /* @__PURE__ */ r(
              q,
              {
                onClick: () => b(c, o),
                children: c
              }
            )
          ] })
        ] }, o);
      }
    ) }),
    v
  ] });
};
D.Footer = B;
export {
  D as SectionedMenu
};
//# sourceMappingURL=index.es5573.js.map
